import axios from 'axios'

/**
 *
 * @param {*} url :api url
 * @param {*} method :api method
 * @param {*} config :api config(headers, params, data...) https://axios-http.com/docs/req_config
 * @returns
 */
const externalFetch = async (url = '', method = 'get', config = {}) => {
  const input = {
    url,
    method,
    ...config
  }
  console.log('input: ', input)
  const response = await axios(input)
    .then((res) => {
      console.log('externalFetch res: ', res)
      return res
    })
    .catch((err) => {
      console.log('externalFetch err: ', err)
      return err
    })
  return response
}

export { externalFetch }
